/**
 * Validates a custom domain URL
 * @param {string} url - The URL to validate
 * @returns {Object} - Object with valid boolean and optional error message
 */
export const validateCustomDomain = (url) => {
    if (!url) return { valid: false, message: 'Custom domain is required' };

    // Check if URL ends with slash
    if (!url.endsWith('/')) {
        return { valid: false, message: 'URL must end with a slash (/)' };
    }

    // Count slashes - should be exactly 3 (two from https:// and one at the end)
    const slashCount = (url.match(/\//g) || []).length;
    if (slashCount !== 3) {
        return { valid: false, message: 'URL should only contain a domain (e.g., https://example.com/)' };
    }

    return { valid: true };
};

/**
 * Validates a template path to ensure it ends with a slash
 * @param {string} path - The template path to validate
 * @returns {Object} - Object with valid boolean and optional error message
 */
export const validateTemplatePath = (path) => {
    if (!path) return { valid: true }; // Empty is valid (field might be optional)

    // Extract the path part, before any query parameters
    const pathPart = path.split('?')[0];

    // Check if path ends with slash
    if (!pathPart.endsWith('/')) {
        return { valid: false, message: 'Template path must end with a slash (/)' };
    }

    return { valid: true };
}; 